import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./utils/reportWebVitals";
import App from "./App";

import { ThemeProvider } from "./contexts/ThemeContext";
import { AppProvider } from "./contexts/AppContext";
import LoadGoogleMaps from "./utils/LoadGoogleMaps";

ReactDOM.render(
  <BrowserRouter>
    <AppProvider>
      <ThemeProvider>
        <LoadGoogleMaps onLoad={() => console.log("Google Maps loaded")} />
        <App />
      </ThemeProvider>
    </AppProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
